module.exports = __webpack_public_path__ + "img/flat-color-icons_google.4092c730.svg";